export const FirebaseConfig = {
	"projectId": "salis-drive",
	"appId": "1:933895490187:web:c1a6e1c9ae187d7675e28e",
	"databaseURL": "https://salis-drive-default-rtdb.firebaseio.com",
	"storageBucket": "salis-drive.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyBfdwouaz9KDt47GNuyxHnevcVnd2aezoA",
	"authDomain": "salis-drive.firebaseapp.com",
	"messagingSenderId": "933895490187",
	"measurementId": "G-7S1W2H87NS"
};